import { IHttpAgent } from '@sparelabs/http-client-utils'
import {
  IDetectLanguageRequest,
  IDetectLanguageResponse,
  ITranslateTextRequest,
  ITranslateTextResponse,
  ITranslateTextsRequest,
  ITranslateTextsResponse,
} from '../types/TranslationTypes'
import { Resources } from './ResourcesType'

export class TranslationResource {
  private readonly agent: IHttpAgent

  constructor(agent: IHttpAgent) {
    this.agent = agent
  }

  /**
   * Translate a single text to the target language
   */
  public async translateText(request: ITranslateTextRequest): Promise<ITranslateTextResponse> {
    const response = await this.agent.post<ITranslateTextResponse>(Resources.TranslateText, request)
    return response.data
  }

  /**
   * Translate multiple texts to the target language
   */
  public async translateTexts(request: ITranslateTextsRequest): Promise<ITranslateTextsResponse> {
    const response = await this.agent.post<ITranslateTextsResponse>(Resources.TranslateTexts, request)
    return response.data
  }

  /**
   * Detect the language of a text
   */
  public async detectLanguage(request: IDetectLanguageRequest): Promise<IDetectLanguageResponse> {
    const response = await this.agent.post<IDetectLanguageResponse>(Resources.TranslateDetect, request)
    return response.data
  }
}
